module.exports = __webpack_public_path__ + "static/app-store-light-8f4a4f4fa300ab9bd1e6a38513dde95f.svg";